import $ from 'jquery';

export default () => {
    const anchorLinks = $('[href^="#"]');
    const footerLinks = $('.SiteFooter__nav--secondary a');
    const chatScript = $(
        'script[src="https://chat.outboundengine.com/c/Challenger_Homes_Kyle_Fisk_min.js"]'
    );
    const chatButtons = $('.js-start-chat');

    if (chatScript.length > 0) {
        chatButtons.parent().show();
    } else {
        chatButtons.parent().hide();
    }

    chatButtons.on('click', function(e) {
        if (typeof ReadyChat === 'object') {
            ReadyChat.startPreChat();
            e.preventDefault();
        }
    });

    $(window).on('load', function() {
        if (window.location.hash) {
            scrollToSectionId(window.location.hash);
        }
    });

    anchorLinks.on('click', function(e) {
        const id = $(this).attr('href');
        scrollToSectionId(id);
        e.preventDefault();
    });

    function scrollToSectionId(id) {
        if ($(id).is('*')) {
            const headerHeight = $('.js-site-header').outerHeight();
            const section = $(id);

            $('html, body').animate(
                {
                    scrollTop: section.offset().top - headerHeight
                },
                500
            );
        }
    }
};



// WEBPACK FOOTER //
// ../src/scripts/modules/global.js